import { useGetGraphqlDataQuery, type UseQueryResult } from '@repo/services';
import { Select, type SelectProps } from 'antd';
import { getProducts, type GetProductsType } from 'crm-atoms/queries';
import { useMemo } from 'react';

export interface ProductSelectProps extends Omit<SelectProps, 'options' | 'onFocus' | 'onChange' | 'value'> {
  value?: string[];
  onChange: (value: string[]) => void;
}

export default function ProductSelect({
  value,
  onChange,
  ...props
}: ProductSelectProps) {
  const {
    data,
    isLoading,
  } = useGetGraphqlDataQuery<UseQueryResult<GetProductsType>>({
    document: getProducts,
  });

  const options = useMemo(
    () => data?.products?.map(({ value: val, label }) => ({ value: val, label })) ?? [],
    [data],
  );

  return (
    <Select
      mode="multiple"
      value={value}
      onChange={onChange}
      options={options}
      loading={isLoading}
      optionFilterProp="label"
      placeholder="Select product(s)"
      {...props}
    />
  );
}
